<app-confirm-dialog
  [title]="titleKey | translate"
  [labelCancel]="'ACTIONS.CANCEL' | translate"
>
  {{ contentKey | translate }}
</app-confirm-dialog>
